export const USER_ROLE_FIELDS = [
	{ key: 'name', label: 'Group Name' },
	{ key: 'description', label: 'Description' },
	{ key: 'total', label: 'Total users' },
];
